module.exports = __webpack_public_path__ + "static/img/KZ.2dec2bf6.png";